module.exports = __webpack_public_path__ + "img/casino.bbf4d177.png";